import MultipleUploadFile from './MultipleUploadFile'

export default MultipleUploadFile
